/**
 * This class handles the banner
 * 
 * It removes the banner if the close icon is clicked
 */

export default class ProjectsHandler {
  constructor() {
    this.getDependencies();
    if (!this.dependenciesAvailable()) {
      return;
    }
    this.events();
  }

  /**
   * Checks if all dependencies (HTMLElements) exist
   *
   * @returns {boolean} true if all elements available (not null or undefined), otherwise false
   */
  dependenciesAvailable = () => {
    if (this.projectsContainer == null || this.projectsContainer.length <= 0) return false;
    return true;
  };

  /**
   * Retrieves the needed dependencies (HTMLElements)
   *
   * @returns {void}
   */
  getDependencies = () => {
    this.projectsContainer = document.querySelectorAll(".js__projects_container");
  };

  /**
   * Register needed event handler
   */
  events = () => {

    this.projectsContainer.forEach((container) => {
      let selectField = container.querySelector(".js__project_selectfield");
      let projectElements = container.querySelectorAll(".js__project_container");
      let backgroundElement = container.querySelector(".js__project_bg");

      if (projectElements == null || projectElements.length <= 0) return;

      let selectedFieldExists = selectField != null && selectField.length > 0;
      let backgroundExists = backgroundElement != null;

      if (selectedFieldExists) {
        selectField.addEventListener("change", (event) => {
          let value = event.target.value;
          let classSelector = "." + value;

          projectElements.forEach((element) => {
            element.classList.add('hidden');
          });

          let newActiveElements = container.querySelectorAll(classSelector);
          newActiveElements.forEach((element) => {
            element.classList.remove('hidden');
          });

          if (backgroundExists) {
            this.applyBackgroundPositions(container, backgroundElement);
          }

          document.querySelector('html').scrollTop += 1;
        });
      }

      if (backgroundExists) {

        document.addEventListener('scroll', () => {
          this.applyBackgroundPositions(container, backgroundElement);
        });

        window.addEventListener('resize', () => {
          this.applyBackgroundPositions(container, backgroundElement);
        });
      }

    });

  }

  /**
   * The background Element of the project container (only in vertical-layout) needs to be adjusted 
   * whenever the window is resized and of course initially. 
   * It always sticks to the center of the first image and the center of the last image.
   * 
   * @param {*} container 
   * @param {*} backgroundElement 
   */
  applyBackgroundPositions = (container, backgroundElement) => {
    let offsetFromTop = 0;
    let offsetFromTopLastImage = 0;
    let offsetFromBottom = 0;
    let marginBottom = 80;
    // get the first image of the .js__project_container (only if it is visible and dont have the .hidden class)
    let firstProjectImage = container.querySelector(".js__project_container:not(.hidden) .js__project_first_img");

    // get the center of the first image and the center of the last image
    if (firstProjectImage != null) {
      let imageHalfHeight = firstProjectImage.offsetHeight / 2;
      offsetFromTop = firstProjectImage.offsetTop + imageHalfHeight;

      // the offset from bottom is the distance from the bottom of the container to the center of the last image 
      offsetFromBottom = imageHalfHeight + marginBottom;
    }

    // set the background element to the center of the first and last image
    backgroundElement.style.top = offsetFromTop + "px";
    backgroundElement.style.bottom = offsetFromBottom + "px";
  };
}